<template>
  <div
    class="btn-group"
    :class="[isRight && 'btn-group--right', isInline && 'btn-group--inline']"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      isRight: {
        type: Boolean,
        default: false
      },
      isInline: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .btn-group {
    display: flex;
    align-items: flex-start;
    .btn + .btn {
      margin-left: 10px;
    }
    &--right {
      justify-content: flex-end;
    }
    &--inline {
      display: inline-flex;
    }
  }
</style>
